import { Tooltip } from 'antd';

const renderWithTooltipIfNeeded = (value) => {
  return value?.length > 30
    ? <Tooltip title={value} placement='bottom'><span className="line-clamp-2">{value}</span></Tooltip>
    : <span className="line-clamp-2">{value}</span>
}

export default renderWithTooltipIfNeeded;